import type { RouteRecordRaw } from 'vue-router'

import { registerDataExportMessages } from './i18n'

import { useLocaleStore } from '@/shared/i18n'

/**
 * v3 declared this route as a bare `{path, name, component}` with **no** `meta` at all
 * (`router/routes/app.js:323-327`) and gated the page from inside the component: an `onMounted`
 * `router.push({ name: 'Summary' })` when `export_hub_scheduled_export_limit_` was missing
 * (`views/App/DataExport.vue:116-121`), which did not even `return` afterwards — the page mounted
 * and fetched anyway. The gate is now route metadata, so 05's `permissionGuard` denies BEFORE the
 * component exists and lands the user on Summary (`permissionAccess.ts:32` → `HOME_ROUTE_NAME`).
 *
 * The permission key is a LITERAL rather than the store's `SCHEDULED_LIMIT_PERMISSION`: route
 * records are evaluated when the router is constructed, so importing the store here would pull the
 * feature's store + service + api into the eager app bundle behind a lazy `component`.
 *
 * `layout: 'app'` is not declared: the '/' parent owns it and vue-router merges matched metas
 * (`app/router/routes/index.ts:51`), which is why no feature route in the repo restates it.
 */
export const dataExportRoutes: RouteRecordRaw[] = [
  {
    path: 'data-export',
    name: 'DataExport',
    component: () => import('./components/pages/DataExportPage.vue'),
    meta: {
      requiresAuth: true,
      permission: 'export_hub_scheduled_export_limit_',
      navKey: 'dataExport',
      titleKey: 'dataExport.page.title',
    },
    beforeEnter: () => registerDataExportMessages(useLocaleStore().locale),
  },
]
